import type { Space } from '@cocoonspace/sdk-js/types/space'

import { bookingConfig } from '../config/booking-config'

export interface RecurringSpaceTypeformParams {
	space: Pick<Space, 'title'>
	days?: string[]
	startDate?: string
}

export const getRecurringSpaceTypeformURLSidebar = ({
	space,
	days,
	startDate,
}: RecurringSpaceTypeformParams) => {
	const searchParams = new URLSearchParams()

	searchParams.set('cocoon', space.title)

	if (days?.[0]) {
		searchParams.set('day1', days[0].toString())
	}

	if (days?.[1]) {
		searchParams.set('day2', days[1].toString())
	}

	if (startDate) {
		searchParams.set('startdate', startDate)
	}

	return `${
		bookingConfig.recurring.typeformRecurringBookingURL.sidebar
	}#${searchParams.toString()}`
}

interface RecurringSpaceTypeformPricingSection {
	space: Pick<Space, 'title'>
	prices: string[]
}

export const getRecurringSpaceTypeformURLPricingSection = ({
	space,
	prices,
}: RecurringSpaceTypeformPricingSection) => {
	const searchParams = new URLSearchParams()

	searchParams.set('cocoon', space.title)
	searchParams.set('priceHours', prices[0])
	searchParams.set('priceDays', prices[1])

	return `${
		bookingConfig.recurring.typeformRecurringBookingURL.pricingSection
	}#${searchParams.toString()}` as const
}
